(function () {
  if (window.cardSwatchesInitialised) return;
  window.cardSwatchesInitialised = true;

  document.addEventListener(
    "click",
    function (e) {
      if (!(e.target instanceof Element)) return;

      const swatch = e.target.closest(".swatch");
      if (!swatch) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const newImage = swatch.dataset.image;
      if (!newImage) return;

      const card = swatch.closest(
        ".product-card, .recommended-product, .grid__item"
      );

      if (!card) return;

      const mainImg = card.querySelector(
        "img:not(.brand-logo)"
      );

      if (!mainImg) return;

      mainImg.src = newImage;

      if (mainImg.hasAttribute("srcset")) {
        mainImg.srcset = newImage;
      }
    },
    true
  );
})();